import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/parkTempCarBill/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/parkTempCarBill/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/parkTempCarBill/remove/v2', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/parkTempCarBill/submit/v2', params, options);

export const update = (params, options) =>
  request.post('/api/parkTempCarBill/submit/v2', params, options);

export const getCarOnlinePayLogByBillId = (params, options) =>
  request.get('/api/car/onLine/payLog/page/v2', Object.assign({}, options, {
    params
  }));

export const getFreeOpenReason = (params, options) =>
  request.get('/api/client/v4ward/car/freeOpenReason/getFreeOpenReason/v2', Object.assign({}, options, {
    params
  }));

// 获取免费开闸原因
export const getReason = (params, options) =>
  request.get('/api/parkTempCarBill/getReason/v2', Object.assign({}, options, {
    params
  }));
